(function () {
  if (!document.body.classList.contains('template-product')) return;

  var anchor = document.querySelector('[data-valor-atc-anchor]');
  var sticky = document.querySelector('[data-valor-sticky-atc]');
  if (!anchor || !sticky) return;

  var stickyBtn = sticky.querySelector('[data-valor-sticky-submit]');
  var stickyPrice = sticky.querySelector('[data-valor-sticky-price]');
  var mainBtn = document.querySelector('[data-add-to-cart]');
  var mainPrice = document.querySelector('[data-product-price]');
  var formId = sticky.getAttribute('data-form-id');
  var form = formId ? document.getElementById(formId) : null;

  function syncStickyState() {
    if (!mainBtn || !stickyBtn) return;
    stickyBtn.disabled = mainBtn.disabled;
    var label = mainBtn.querySelector('[data-add-to-cart-text]');
    if (label) {
      stickyBtn.textContent = label.textContent.trim();
    }
    if (mainPrice && stickyPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }
  }

  function setVisible(show) {
    sticky.classList.toggle('valor-sticky-atc--visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('valor-sticky-atc-active', show);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0, rootMargin: '0px' }
    );
    observer.observe(anchor);
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      }
    });
  }

  if (mainPrice && stickyPrice) {
    var priceObserver = new MutationObserver(syncStickyState);
    priceObserver.observe(mainPrice, { childList: true, characterData: true, subtree: true });
  }

  if (mainBtn) {
    var btnObserver = new MutationObserver(syncStickyState);
    btnObserver.observe(mainBtn, { attributes: true, childList: true, subtree: true });
  }

  document.addEventListener('variant:change', syncStickyState);
  syncStickyState();
})();
